export const navLinkList = [
    {
        path: 'https://docs.pixelstrap.net/admin/riho/document/',
        image: '2.png',
        name: 'Document',
        class:"fa-spin"
    },
    {
        path: 'https://themeforest.net/user/pixelstrap/portfolio',
        image: '3.png',
        name: 'Buy Now'
    },
    {
        path: 'http://127.0.0.1:5500/template/landing-page.html',
        image: '4.png',
        name: 'Check Features'
    },
    {
        path: 'https://support.pixelstrap.com',
        image: '5.png',
        name: 'Support'
    }
]

export const lightColorData = [
    {
        primary:"#43b9b2",
        secondary:"#c280d2"
    },
    {
        primary:"#0F2C59",
        secondary:"#DAC0A3"
    },
    {
        primary:"#7A3E65",
        secondary:"#E9A178"
    },
    {
        primary:"#025464",
        secondary:"#E57C23"
    },
    {
        primary:"#3E64FF",
        secondary:"#5EDFFF"
    },
    {
        primary:"#506D84",
        secondary:"#D4B499"
    }
]

export const mixLayoutData = [
    {
        image:"light.png",
        color:"light",
        title:"LIGHT",
        layout:"light"
    },
    {
        class:"mx-1",
        image:"dark.png",
        color:"dark",
        title:"Dark",
        layout:"dark"
    },
    {
        image:"mix.png",
        color:"mix",
        title:"Mix",
        layout:"dark-sidebar"
    }
]

export const sidebarIconData = [
    {
        class:"default-svg",
        icon:"Activity",
        title:"Stroke",
        id:"radio-icon5",
        check:true
    },
    {
        class:"colorfull-svg",
        icon:"Activity",
        title:"Colorfull icon",
        id:"radio-icon6"
    },
]

export const layoutTypeData  = [
    {
        id:"flexRadioDefault1",
        title:"LTR",
        checked:true,
        class:"ltr"
    },
    {
        id:"flexRadioDefault2",
        title:"RTL",
        class:"rtl"
    },
    {
        id:"flexRadioDefault3",
        title:"Box",
        class:"box"
    }
]

export const sidebarTypeData = [
    {
       class:"vertical",
       id:"radio-icon" ,
       title:"Vertical",
       checked:true
    },
    {
        class:"horizontal",
        id:"radio-icon4" ,
        title:"Horizontal",
    }
]